import styled from 'styled-components';

export const Wrapper = styled.div``;

export const RowDash = styled.span`
  align-items: stretch;
  justify-content: space-between;
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    flex-direction: column;
  }
`;

export const CardHead = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;
export const CardService = styled.div`
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    flex-direction: column !important;
  }
`;
export const RowTable = styled.div`
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    flex-direction: column !important;
  }
`;
export const RowItemTable = styled.div`
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    margin-inline-end: 0 !important;
    margin-bottom: ${({ theme }) => theme.spacing.x4};
  }
`;
export const Exchange = styled.div`
  // @media (max-width: ${({ theme }) => theme.media.lg}) {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  // }
`;
export const Services = styled.div`
  height: 100%;
`;
export const MenuItem = styled.div`
  background: ${({ theme }) => theme.palette.secondary7};
  border-radius: ${({ theme }) => theme.radius.sm};
  padding: ${({ theme }) => theme.spacing.x3};

  &:not(&:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.x3};
  }
`;
export const Col = styled.div`
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    align-items: center;
    margin-top: ${({ theme }) => theme.spacing.x3};
    order: 3;
    justify-content: center;

    gap: 20px;
    flex-direction: row;
    @media (max-width: ${({ theme }) => theme.media.sm}) {
      gap: 0px;
    }
  }
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: column;
  }
`;

export const CreditCard = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x2};
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    margin-bottom: 0;
  }
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    margin-bottom: ${({ theme }) => theme.spacing.x2};
  }
`;

export const ParentTier = styled.div`
  width: 100%;
`;
